/** Kawalan "lihat pada titik ini" dalam sejarah kes dan sepanduk pengesahan rantaian (Fasa 2 P2-1). */
export default {
  history: {
    viewAsAt: 'Lihat pada titik ini',
    viewAsAtSeq: 'Lihat pada titik ini (peristiwa #{{seq}})',
    viewingAsAt: 'Pada peristiwa #{{seq}}, {{time}}',
    viewingAsAtSeq: 'Pada peristiwa #{{seq}}',
    backToCurrent: 'Kembali ke kes semasa',
    chainProven: 'Disahkan oleh rantaian',
    notChainProven: 'Tidak disahkan oleh rantaian',
    notChainProvenHint:
      'Sejarah sehingga titik ini tidak lagi dapat disahkan, atau sesetengah fail atau laporan semakan pada titik ini direkodkan sebelum sejarah menyimpan ringkasan cincangnya, atau tidak lagi sepadan dengannya.',
    stage: 'Peringkat',
    revision: 'Versi',
    title: 'Tajuk',
    documents: 'Fail pada titik ini',
    submissions: 'Keputusan semakan pada titik ini',
    none: 'Tiada',
    reused: 'diguna semula',
    loadFailed: 'Titik dalam sejarah ini tidak dapat dimuatkan.',
    loading: 'Memuatkan titik dalam sejarah ini…',
  },
  chain: {
    broken:
      'Sejarah penyerahan ini gagal pengesahan pada peristiwa #{{seq}} (disemak {{time}}). Tiada apa-apa yang diubah. Hubungi sokongan.',
  },
} as const
